import { render, staticRenderFns } from "./TemplatesFilter.vue?vue&type=template&id=1c985bde&"
import script from "./TemplatesFilter.vue?vue&type=script&lang=ts&"
export * from "./TemplatesFilter.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports